import { isQQBrowser } from './browser'

// 清除价格零
export const clearPriceZero = (old) => {
  if (!old) return old
  //拷贝一份 返回去掉零的新串
  let newstr = old
  //循环变量 小数部分长度
  var leng = old.length - old.indexOf('.') - 1
  //判断是否有效数
  if (old.indexOf('.') > -1) {
    //循环小数部分
    for (let i = leng; i > 0; i--) {
      //如果newstr末尾有0
      if (newstr.lastIndexOf('0') > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
        var k = newstr.lastIndexOf('0')
        //如果小数点后只有一个0 去掉小数点
        if (newstr.charAt(k - 1) == '.') {
          return newstr.substring(0, k - 1)
        } else {
          //否则 去掉一个0
          newstr = newstr.substring(0, k)
        }
      } else {
        //如果末尾没有0
        return newstr
      }
    }
  }
  return old
}

// 判断是否为json
export function isJSON(str) {
  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj == 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      console.log('error：' + str + '!!!' + e)
      return false
    }
  }
  console.log('It is not a string!')
}

// 获取html字符串body内容
export function getHtmlStringBodyContent(htmlString) {
  if (htmlString.length === 0) {
    return ''
  }
  var rx = /<body[^>]*>([\s\S]+?)<\/body>/i ///
  var m = rx.exec(htmlString)
  return m[1]
}

export function getURLParam(query) {
  let result = ''
  if (query) {
    Object.keys(query).forEach((key) => {
      result += key + '=' + query[key] + '&'
    })
    result = result.substring(0, result.length - 1)
  }
  return result
}

export const formatSingleNumber = (number) => {
  return number <= 9 ? '0' + number : number
}

export function setWxShare(options = {}) {
  let { title, desc, link, imgUrl } = { ...options }
  wx.ready(function () {
    //需在用户可能点击分享按钮前就先调用
    let options = {
      title: title || '精品课程', // 分享标题
      desc: desc || '精品课程分享', // 分享描述
      link: link || window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl:
        imgUrl ||
        'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/pingtuan/share.png', // 分享图标
    }
    wx.updateAppMessageShareData(options)
    wx.updateTimelineShareData(options)
  })
}

export function setShare(param) {
  const wxParam = {}
  param?.title && (wxParam.title = param.title)
  param?.desc && (wxParam.desc = param.desc)
  param?.imgUrl && (wxParam.imgUrl = param.imgUrl)
  param?.link && (wxParam.link = param.link)
  setWxShare(wxParam)
  if (isQQBrowser()) {
    const qqParam = {}
    param?.title && (qqParam.title = param.title)
    param?.desc && (qqParam.summary = param.desc)
    param?.imgUrl && (qqParam.pic = param.imgUrl)
    param?.link && (qqParam.url = param.link)
    window.setShareInfo && window.setShareInfo(qqParam)
  }
  if (param?.title) {
    document.title = param.title

    const img = document.getElementById('share_img')
    // 修改 img 元素的 src 属性
    img.src = param.imgUrl

    // 获取meta标签
    var meta = document.querySelector('meta[name="description"]')
    // 修改meta标签的content属性
    meta.content = param?.desc
  }
}

// 格式化为url参数
export function objectToQuery() {
  let obj = arguments[0]
  let prefix = arguments[1]
  if (typeof obj !== 'object') return ''
  const attrs = Object.keys(obj)
  return attrs.reduce((query, attr, index) => {
    if (index === 0 && !prefix) query += '?'
    if (typeof obj[attr] === 'object') {
      const subPrefix = prefix ? `${prefix}[${attr}]` : attr
      query += this.objectToQuery(obj[attr], subPrefix)
    } else {
      if (prefix) {
        query += `${prefix}[${attr}]=${obj[attr]}`
      } else {
        query += `${attr}=${obj[attr]}`
      }
    }
    if (index !== attrs.length - 1) query += '&'
    return query
  }, '')
}

// 修改页面url
export function replacePageState(param, text, url) {
  history.replaceState(param, text, url)
}
export function windowLocationHref(url) {
  window.location.href = url
}
